export default "__VITE_ASSET__Bft6g_MU__"